import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { ProtocolHDModel } from 'src/app/models/ProtocolHDModel';
import { ProtocolHDService } from 'src/app/services/ProtocolHDService';
import { ProtocolDetModel } from 'src/app/models/ProtocolDetModel';
import { ProtocolDetService } from 'src/app/services/ProtocolDetService';
import { ProtocolsearchComponent } from '../protocolsearch/protocolsearch.component';
import { ItemsModel } from 'src/app/models/ItemsModel';
import { LocalStorageService } from 'ngx-webstorage';
import {formatDate} from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { PharmGroupModel } from 'src/app/models/PharmGroupModel';
import { PharmGroupService } from 'src/app/services/PharmGroupService';
import { ItemsService } from 'src/app/services/ItemsService';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { ProtocolEditComponent } from '../protocol-edit/protocol-edit.component';

@Component({
  selector: 'app-protocols',
  templateUrl: './protocols.component.html',
  styleUrls: ['./protocols.component.css']
})
export class ProtocolsComponent implements OnInit {
  prHdCode ='';
  prHdName ='';
  prHdCycle =0;
  prHdDays =0;
  prHdNotes ='';
  compCode ='1';
  userID ='sa';
  modifiedDate ='2022-01-01';
  itGrouping ='';

  prDetCategory='1' ;
  prDetCategory2='2' ;
  prDetCategory3='' ;
  prDetCatName ='';
  prDetItCode ='' ;
  prDetItName = '';
  prDetUnit ='' ;
  prDetDose = 0;

  prDetRote = 0;
  prDetDuration ='' ;
  prDetNotes ='' ;
  prDetStep ='1' ;

  prDetDuration1 ='' ;
  prDetNotes1 ='' ;
  prDetStep1 ='1' ;

  prDetDuration2 ='' ;
  prDetNotes2 ='' ;
  prDetStep2 ='1' ;

  prDuration ='';
  itCode ='';
  itCode1 ='';
  itCode2 ='';

  itTName = '';
  itTName1 ='';
  itTName2 ='';

  prDetQty =0;
  prDetQty1 =0;
  prDetQty2 =0;

  pharmacyGroupName ='';
  pharmGroupList: PharmGroupModel[] =[];
  itemsList: ItemsModel[] =[];
  itemsList1: ItemsModel[] =[];
  itemsList2: ItemsModel[] =[];
  PreMedicationList: ProtocolDetModel[] = [];
  ChemoList: ProtocolDetModel[] = [];
  SupprtList: ProtocolDetModel[] = [];
  @Output() submitClicked = new EventEmitter<any>();

  constructor( public protocolHDService: ProtocolHDService,
               public ProtocolHD: ProtocolHDModel,
               public itemsSelectedData:ProtocolHDModel,
               public protocolDet: ProtocolDetModel,
               public PreMedicationSelectedData: ProtocolDetModel,
               public protocolDetService:ProtocolDetService,
               public pharmgroupService: PharmGroupService,
               public itemsService: ItemsService,
               public storage: LocalStorageService,
               public ProtocolHDSelectedData: ProtocolHDModel,
               private dialogref: MatDialog,

               public route: Router ) { }

  ngOnInit(): void {
    this.retriveNextHD();


  }
    //// ---------------- Get Next Serial ------------------------
    retriveNextHD() {
      this.protocolHDService.getNextSerial(this.storage.retrieve('stgcompCode'))
        .subscribe((data: ProtocolHDModel) => {
          this.prHdCode = data.prHdCode;
        });
    }
  ///--------------------- Headers -------------------------------------------------------
  retriveProtocolHD(){
    this.protocolHDService.getProtocolHD(this.prHdCode).subscribe((data: ProtocolHDModel) => {

      this.prHdName = data.prHdName;
      this.prHdCycle = data.prHdCycle;
      this.prHdDays = data.prHdDays;
      this.prHdNotes = data.prHdNotes;

      this.compCode = data.compCode;
      this.userID = data.userID;
      this.modifiedDate = data.modifiedDate;
      this.retrivePreMedication();
      this. retriveChemo();
      this.retriveSupprtive();


    }
    );
  }
  submitProtocolHD() {
    this.ProtocolHD.prHdCode = this.prHdCode;
    this.ProtocolHD.prHdName = this.prHdName;
    this.ProtocolHD.prHdCycle = this.prHdCycle;
    this.ProtocolHD.prHdDays = this.prHdDays;
    this.ProtocolHD.prHdNotes = this.prHdNotes;
    this.ProtocolHD.userID = this.storage.retrieve('stguserId');
    this.ProtocolHD.modifiedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.ProtocolHD.compCode = this.storage.retrieve('stgcompCode');

    this.protocolHDService.AddProtocolHD(this.ProtocolHD).subscribe(data => {

      this.mesgSave();
      this.NewData();

    },

      error => { alert(error); }

    );

  }
  NewData() {
    this.retriveNextHD();
    this.prHdName = '';
    this.prHdCycle =0;
    this.prHdDays =0;
    this.prHdNotes ='';
    this.compCode = this.storage.retrieve('stgcompCode');
    this.userID = this.storage.retrieve('stguserId');
    this.modifiedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.PreMedicationList = [];
    this.ChemoList=[];
    this.SupprtList= [];
  }
  deleteProtocolHD() {                                                   ///----------- for searching pop up -----------
    this.protocolHDService.delProtocolHD(this.prHdCode).subscribe(
      (data: ProtocolHDModel) => {

      }
    );
    this.deleteProtocolDet();
    this.NewData();
  }
  ///////////******************** Detailed  **************************/
  deleteProtocolDet() {                                                   ///----------- for searching pop up -----------
    this.protocolDetService.delProtocolDetAll(this.prHdCode).subscribe(
    (data: ProtocolDetModel) => {

      this.prDetCategory='1' ;
      this.prDetCategory2='2' ;
      this.prDetCategory3='' ;

    }
  );
}

////--------------------  Messages ------------------------------------------------------------
  mesgDelete() {
    Swal({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(() => {
        this.deleteProtocolHD();
        Swal('Deleted!', 'Your record has been deleted.', 'success');

      },
      function (dismiss) {
        if (dismiss === 'cancel') {
          Swal('Cancelled', 'Your record is safe :)', 'error');
        }
      }
    );
  }
  mesgSave() {
    Swal({
    title: 'Your work has been saved',

    type: 'success',
    showConfirmButton: false,

    timer: 1500
    });
  }

  ///================================ Update Lines ================================
  ///-------------------------- Update Line in PreMedication1 ---------------------

  retrivePreMedication() {
    this.PreMedicationList = [];
    this.protocolDetService.getProtocolDetCat(this.prHdCode,'1').subscribe((data: ProtocolDetModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.PreMedicationList[i] = data[i];
        }

      });

  }
   ///-------------------------- Update Line in PreMedication1 ---------------------

   retriveChemo() {
    this.ChemoList = [];
    this.protocolDetService.getProtocolDetCat(this.prHdCode,'2').subscribe((data: ProtocolDetModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.ChemoList[i] = data[i];
        }
      });

  }
 ///-------------------------- Update Line in Supportive  -------------------------
  retriveSupprtive() {
    this.SupprtList = [];
    this.protocolDetService.getProtocolDetCat(this.prHdCode,'3').subscribe((data: ProtocolDetModel[]) => {

      for (let i = 0; i < data.length; i++) {
          this.SupprtList[i] = data[i];
        }
      });

  }

  SelectPreMedication(pro: ProtocolDetModel) {

    this.prDetCategory = pro.prDetCategory;
    this.PreMedicationSelectedData.prDetCatName = pro.prDetCatName;
    this.itCode = pro.prDetItCode;

    this.PreMedicationSelectedData.prDetItName = pro.prDetItName;

    this.itTName=pro.prDetItName;

    if (pro.prDetCategory === '1'){
      this.itCode = pro.prDetItCode;
      this.prDetQty = pro.prDetQty;
      this.prDetDuration= pro.prDetDuration;
      this.prDetStep = pro.prDetStep;
      this.prDetNotes= pro.prDetNotes;
      this.openDialogEditP(pro);

    }
    if (pro.prDetCategory === '2') {
      this.itCode1 = pro.prDetItCode;
      this.prDetQty1 = pro.prDetQty;
      this.prDetDuration1= pro.prDetDuration;
      this.prDetStep1 = pro.prDetStep;
      this.prDetNotes1= pro.prDetNotes;
      this.openDialogEditC(pro);
    }
      if (pro.prDetCategory === '3') {
        this.itCode2 = pro.prDetItCode;
        this.prDetQty2 = pro.prDetQty;
        this.prDetDuration2= pro.prDetDuration;
        this.prDetStep2 = pro.prDetStep;
        this.prDetNotes2= pro.prDetNotes;
        this.openDialogEditS(pro);
      }

    this.submitClicked.emit(this.PreMedicationSelectedData);
  }
  openDialogEditP(pro: ProtocolDetModel) {

       const dialogRef = this.dialogref.open(ProtocolEditComponent, {
      data: {
        dataKey: this.protocolDet,
        prhdcode:this.prHdCode,
        prdetcategory : pro.prDetCategory,
        prdetitcode : pro.prDetItCode,
        prdetitname : pro.prDetItName,
        prdetdose : pro.prDetDose ,
        prdetqty : pro.prDetQty ,
        prunit : pro.prDetUnit,
        prdetrote : pro.prDetRote ,
        prdetduration : pro.prDetDuration,
        prdetnotes :pro.prDetNotes ,
        prdetstep : pro.prDetStep,
        linestatus : 'Edit'

      },
    });
    dialogRef.afterClosed().subscribe(result => {
      //this.retriveProtocolHD();
      this.retrivePreMedication();
    });

  }

  AddNewPreNedicationLine(){
    const dialogRef = this.dialogref.open(ProtocolEditComponent, {
      data: {
        dataKey: this.protocolDet,
        prhdcode:this.prHdCode,
        prdetcategory : '1',
        prdetitcode : '',
        prdetitname : '',
        prdetdose : 0 ,
        prdetqty : 0 ,
        prunit : '',
        prdetrote : 0 ,
        prdetduration : '',
        prdetnotes :'' ,
        prdetstep : '',
        linestatus : 'New'

      },
    });
    dialogRef.afterClosed().subscribe(result => {
      // this.PreMedicationList = [];
      // this.protocolDetService.getProtocolDetCat(this.prHdCode,'1').subscribe((data: ProtocolDetModel[]) => {
      //   for (let i = 0; i < data.length; i++) {
      //     this.PreMedicationList[i] = data[i];
      //   }
      //   this.ChemoList = [];
      //   this.protocolDetService.getProtocolDetCat(this.prHdCode,'2').subscribe((data: ProtocolDetModel[]) => {
      //       for (let i = 0; i < data.length; i++) {
      //         this.ChemoList[i] = data[i];
      //       }
      //     });
      // });
        this.retrivePreMedication();

    });

  }
  AddNewChemoLine(){
    const dialogRef = this.dialogref.open(ProtocolEditComponent, {
      data: {
        dataKey: this.protocolDet,
        prhdcode:this.prHdCode,
        prdetcategory : '2',
        prdetitcode : '',
        prdetitname : '',
        prdetdose : 0 ,
        prdetqty : 0 ,
        prunit : '',
        prdetrote : 0 ,
        prdetduration : '',
        prdetnotes :'' ,
         prdetstep :'',
        linestatus : 'New'


      },
    });
    dialogRef.afterClosed().subscribe(result => {
      // this.PreMedicationList = [];
      // this.protocolDetService.getProtocolDetCat(this.prHdCode,'1').subscribe((data: ProtocolDetModel[]) => {
      //   for (let i = 0; i < data.length; i++) {
      //     this.PreMedicationList[i] = data[i];
      //   }
      //   this.ChemoList = [];
      //   this.protocolDetService.getProtocolDetCat(this.prHdCode,'2').subscribe((data: ProtocolDetModel[]) => {
      //       for (let i = 0; i < data.length; i++) {
      //         this.ChemoList[i] = data[i];
      //       }
      //     });
      // });
      this. retriveChemo();


    });
  }
  AddNewSupportiveLine(){
    const dialogRef = this.dialogref.open(ProtocolEditComponent, {
      data: {
        dataKey: this.protocolDet,
        prhdcode:this.prHdCode,
        prdetcategory : '3',
        prdetitcode : '',
        prdetitname : '',
        prdetdose : 0 ,
        prdetqty : 0 ,
        prunit : '',
        prdetrote : 0 ,
        prdetduration : '',
        prdetnotes :'' ,
         prdetstep : '',
        linestatus : 'New'


      },
    });
    dialogRef.afterClosed().subscribe(result => {
      this.retriveSupprtive();

    });
  }
  openDialogEditC(pro: ProtocolDetModel) {
    const dialogRef = this.dialogref.open(ProtocolEditComponent, {
    data: {
     dataKey: this.protocolDet,
     prhdcode:this.prHdCode,
     prdetcategory : pro.prDetCategory,
     prdetitcode : pro.prDetItCode,
     prdetitname : pro.prDetItName,
     prdetdose : pro.prDetDose ,
     prdetqty : pro.prDetQty ,
     prunit : pro.prDetUnit,
     prdetrote : pro.prDetRote ,
     prdetduration : pro.prDetDuration,
     prdetnotes :pro.prDetNotes ,
     prdetstep : pro.prDetStep,

        linestatus : 'Edit'

   },
 });
   dialogRef.afterClosed().subscribe(result => {

    this.ChemoList = [];
    this.protocolDetService.getProtocolDetCat(this.prHdCode,'2').subscribe((data: ProtocolDetModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.ChemoList[i] = data[i];
        }
      });

 });
 this.retriveChemo();
}
openDialogEditS(pro: ProtocolDetModel) {
  const dialogRef = this.dialogref.open(ProtocolEditComponent, {
  data: {
   dataKey: this.protocolDet,
   prhdcode:this.prHdCode,
   prdetcategory : pro.prDetCategory,
   prdetitcode : pro.prDetItCode,
   prdetitname : pro.prDetItName,
   prdetdose : pro.prDetDose ,
   prdetqty : pro.prDetQty ,
   prunit : pro.prDetUnit,
   prdetrote : pro.prDetRote ,
   prdetduration : pro.prDetDuration,
   prdetnotes :pro.prDetNotes ,
   prdetstep : pro.prDetStep,
   linestatus : 'Edit'

 },
});
 dialogRef.afterClosed().subscribe(result => {

  this.SupprtList = [];
  this.protocolDetService.getProtocolDetCat(this.prHdCode,'3').subscribe((data: ProtocolDetModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.SupprtList[i] = data[i];
      }
    });

});
this.retriveChemo();
}

  ///================================ Delete Lines ================================
  ///------------------------** Delete Line in PreMedication1 ***---------------------
    deletePreNedication() {
         this.protocolDetService.delProtocolDetCat(this.prHdCode,this.prDetCategory,this.itCode,this.prDetStep ).subscribe(
        (data: ProtocolDetModel) => {
          this.retrivePreMedication();
          this.itTName ='';
          this.itCode ='';
          this.prDetQty=0;

        }

      );
    }
    deleteChemo() {
      this.protocolDetService.delProtocolDetCat(this.prHdCode,this.prDetCategory2,this.itCode,this.prDetStep ).subscribe(
      (data: ProtocolDetModel) => {
        this.retriveChemo();
        this.itTName ='';
        this.itCode ='';
        this.prDetQty1=0;

      }
    );

    }
    deleteSupp() {
       this.protocolDetService.delProtocolDetCatSup(this.prHdCode,'1',this.itCode,this.prDetStep ).subscribe(
      (data: ProtocolDetModel) => {
        this.retriveSupprtive();
        this.itTName2 ='';
        this.itCode2 ='';
        this.prDetQty2=0;

      }
    );

    }
///=============================== Dialog Searching ==============================
openDialog(){
  const dialogRef = this.dialogref.open(ProtocolsearchComponent,
    {
      data: {
        dataKey: this.ProtocolHDSelectedData
      },
      width:'80%'
  });
  dialogRef.afterClosed().subscribe(result => {
  });
  const dialogSubmitSubscription =
       dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.prHdCode = result.prHdCode;
        this.prHdName = result.prHdName;
        this.prHdCycle = result.prHdCycle;
        this.prHdDays = result.prHdDays;
        this.prHdNotes = result.prHdNotes;
        dialogSubmitSubscription.unsubscribe();
        this.retrivePreMedication();
      this. retriveChemo();
      this.retriveSupprtive();
      });
}


}
